module.exports = __webpack_public_path__ + "img/15.c5cd5c77.png";